import React, { useState, useEffect } from 'react';
import { COLORS, FONTS, cardStyle, primaryButtonStyle } from '../signup/signupStyles';

export const ScreenerBridge = ({ firstName, condition, onStartReflect, qualified }) => {
  const [showReflectCTA, setShowReflectCTA] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowReflectCTA(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 480px) {
          .opp-bridge-card { padding: 32px 24px !important; }
        }
      `}</style>

      <div className="opp-bridge-card" style={{ ...cardStyle, textAlign: 'center' }}>
        {/* Status icon */}
        <div style={{
          width: '64px', height: '64px', borderRadius: '50%',
          backgroundColor: qualified ? `${COLORS.salmon}15` : `${COLORS.gold}20`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px'
        }}>
          {qualified ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke={COLORS.salmon} strokeWidth="2.5" strokeLinecap="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#c8a44e" strokeWidth="2" strokeLinecap="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          )}
        </div>

        <h1 style={{
          fontFamily: FONTS.serif, fontSize: 'clamp(22px, 4vw, 28px)',
          fontWeight: '700', color: COLORS.text, margin: '0 0 12px'
        }}>
          {qualified
            ? `You're a match, ${firstName}.`
            : `You don't qualify for this one, ${firstName}.`}
        </h1>

        <p style={{
          fontSize: '15px', color: COLORS.muted, lineHeight: 1.6,
          margin: '0 0 8px'
        }}>
          {qualified
            ? "You meet the requirements for this study. We'll be in touch with next steps."
            : "This particular study has specific criteria you didn't meet. That's not unusual — most studies are looking for a narrow group."}
        </p>

        <p style={{
          fontSize: '15px', color: COLORS.muted, lineHeight: 1.6,
          margin: '0 0 32px'
        }}>
          {qualified
            ? `In the meantime — want to see what other ${condition} patients are saying?`
            : `We have other studies that may be a better fit. In the meantime — hear from other ${condition} patients.`}
        </p>

        {showReflectCTA && (
          <div style={{ animation: 'fadeUp 0.4s ease-out' }}>
            <button onClick={onStartReflect} style={{
              ...primaryButtonStyle, width: '100%', padding: '16px 24px',
              marginBottom: '8px'
            }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#3a3a39'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = COLORS.text; }}
            >
              See What Others Are Saying
            </button>
            <p style={{
              fontSize: '12px', color: COLORS.muted, margin: '8px 0 0'
            }}>
              Answer one question, see how others responded
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
